module.exports = __webpack_public_path__ + "static/helmet_img-67d0d740d96e3045e7301ab7eb6fd592.jpg";